import * as React from "react";
import { SubduedDisplaySmall } from "../ActionListModal.styles";

interface Props {
  action: Insite.API.Action;
}

export const ModalSubtitle: React.FC<Props> = ({ action }) => (
  <SubduedDisplaySmall>
    <span>{action.project_name}, </span>
    <span>{action.components}, </span>
    <span style={{ fontStyle: "italic" }}>{action.responsible}</span>
  </SubduedDisplaySmall>
);
